import React from "react";
import DisplayMaster from '../DisplayMaster';

export default function HolyCross() {
  return (
    <>
      <DisplayMaster voivodeship="HolyCross" />
    </>
  );
}